import { mailStart } from './mailStart';

mailStart();
